import { useEffect } from 'react';

function PageInfo(props) {
  useEffect(() => {
    document.title = props.title || "SilverFinish";
    document.querySelector("meta[name='description']").setAttribute("content", props.desc || "Official home of SilverFinish - Software Engineer and Content Creator");
  }, [props.title, props.desc]);
}

export default PageInfo;